export const SUPPORT_EMAIL = 'support@bitstop.co';
export const SUPPORT_PHONE = '+1 (855) 524 8786';